import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import { thumb, onImgError } from './utils/thumb'

Vue.use(Vant)
Vue.config.productionTip = false
// 全局挂载缩略图工具：模板中用 $thumb(url) 取缩略图、@error="$onImgError" 失败时回退原图
Vue.prototype.$thumb = thumb
Vue.prototype.$onImgError = onImgError

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
